<template lang="pug">
  .personal-tile
    .top
      UserTile.user(:user="$store.state.auth.user")
      RouterLink(:to="{ name: 'account' }")
        Icon(name="settings" style="width: 15px; height: 15px")
      RouterLink(:to="{ name: 'account' }")
        Icon(name="edit3")
    .bottom
      .param Ваш баланс
      .value {{ $store.state.auth.user.accountBalance / 100 }} ₽
      .param Ваш тариф
      .value {{ $store.state.auth.user.tariff.name }}
</template>

<script>
import UserTile from '@/components/UserTile.vue';

export default {
  name: 'PersonalTile',
  components: { UserTile },
};
</script>

<style scoped lang="scss">
  .personal-tile {
    background: #FFFFFF;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 30px 25px 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;

    &:before {
      display: block;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 5px;
      background: #C8E7FF;
    }

    @media (max-width: 576px) {
      margin-left: -15px;
      margin-right: -15px;
      border-radius: 0;

      &:before {
        display: none;
      }
    }
  }

  .top {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 20px;
    border-bottom: 1px solid #EBEFF2;
  }

  .user {
    margin-right: auto;
  }

  .bottom {
    margin: auto 0;
    padding-top: 15px;
    display: grid;
    grid-template-columns: auto auto;
  }

  .param {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #889AAD;
  }

  .value {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.01em;
    color: #33A1FB;
    justify-self: end;
  }
</style>
